import { Syllabus } from '@/kontent/content-types'
import { CommonContentTab } from '@/pages/learning-areas/[learningarea]/[syllabus]/[tab]'
import { CommonPageProps } from '@/types'
import { byTaxoCodename } from '@/utils'
import { useRouter } from 'next/router'
import { SyllabusSectionOutcome } from '../syllabus-sections/SyllabusSectionOutcome'

export const Outcome = ({
	data,
}: CommonPageProps<Syllabus, CommonContentTab<Syllabus>>) => {
	const router = useRouter()
	const { query } = router
	const {
		syllabus: syllabusResponse,
		stageGroups: allStageGroups,
		stages: allStages,
	} = data
	const syllabus = syllabusResponse.item
	return (
		<div className="px-4 pt-8">
			<SyllabusSectionOutcome
				syllabus={syllabus}
				syllabusResponse={syllabusResponse}
				currentStages={allStages
					.filter((stage) => {
						if (
							stage.codename === 'life_skills' ||
							// if query `s` & `code` are present, show all stages
							((query.s as string) && (query.code as string))
						) {
							return true
						}
						return syllabus.elements.stages__stages.value
							.map(byTaxoCodename)
							.includes(stage.codename)
					})
					.map(byTaxoCodename)}
				allStageGroups={allStageGroups}
				allStages={allStages}
				lazyAlignedContent={false}
				scrollTargetCode={query.code as string}
				scrollTargetStage={query.s as string}
			></SyllabusSectionOutcome>
		</div>
	)
}

export default Outcome
